import { render, staticRenderFns } from "./NoticesRechargeModal.vue?vue&type=template&id=b86195e0"
import script from "./NoticesRechargeModal.vue?vue&type=script&lang=js"
export * from "./NoticesRechargeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports